import script from "./barcodeScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./barcodeScanner.vue?vue&type=script&setup=true&lang=js"

import "./barcodeScanner.vue?vue&type=style&index=0&id=05e8aeb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e8aeb4"]])

export default __exports__